module.exports = __webpack_public_path__ + "img/tbg.7a9b93c9.png";